// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionDifficultyChip_root__tEXFN","labelWrap":"QuestionDifficultyChip_labelWrap__FK21K","iconSlot":"QuestionDifficultyChip_iconSlot__i2bKv"};